var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.elements.length)?_c('div',{staticClass:"c-accordion-layout"},[_c('div',{staticClass:"\n\t\t\t>=768:flex >=768:justify-between >=768:items-start\n\t\t\talign-baseline\n\t\t\t>=768:gap-(1/4)/12col\n\t\t\tmb-2xs/v\n\t\t"},[(_vm.title)?_c('div',{staticClass:"flex-shrink flex-grow"},[_vm._t("title",function(){return [_c('BaseH2',{domProps:{"textContent":_vm._s(_vm.title)}})]})],2):_vm._e(),_vm._v(" "),(_vm.elements.length > 1)?_c('BaseButton',{staticClass:"\n\t\t\t\tml-auto\n\t\t\t\tmt-16\n\t\t\t\t>=768:mt-0\n\t\t\t\twhitespace-nowrap\n\t\t\t\tjustify-between\n\t\t\t\tflex-shrink-0 flex-grow-0\n\t\t\t",class:[
				'bg-white hover:bg-theme-10 text-theme border border-current' ],on:{"click":function () { return _vm.toggleAll(); }}},[_c('span',{key:_vm.isGroupOpen ? 'open' : 'closed',staticClass:"absolute",domProps:{"textContent":_vm._s(_vm.isGroupOpen ? 'Luk alle' : 'Åben alle')}}),_vm._v(" "),_c('span',{staticClass:"invisible",attrs:{"aria-hidden":"true"},domProps:{"textContent":_vm._s('Åben alle')}}),_vm._v(" "),_c('SvgIconWedge',{class:[
					'ml-1em w-12 h-8 mt-1',
					'transform duration-200 ease-smooth-out',
					{ '-rotate-180 -mt-1': _vm.isGroupOpen } ]})],1):_vm._e()],1),_vm._v(" "),_c('AccordionGroup',_vm._b({ref:"accordionGroup",staticClass:"overflow-hidden isolate"},'AccordionGroup',{ tag: _vm.tag, minOneOpen: _vm.minOneOpen, maxOneOpen: _vm.maxOneOpen },false),_vm._l((_vm.elements),function(item,index){return _c('div',{key:("item-" + index),class:[
				'c-accordion-layout__item',
				_vm.panelsOpen[index]
					? 'c-accordion-layout__item--open'
					: 'c-accordion-layout__item--closed',
				'relative border-t border-b >=1024:border border-gray-medium',
				'transition-colors duration-200 ease-smooth-out',
				{
					'bg-theme >=1024:bg-white': !_vm.panelsOpen[index],
					'bg-white >=1024:bg-theme-20 >=1024:bg-opacity-20':
						_vm.panelsOpen[index],
					'-mt-1': index > 0,
				} ]},[_c('AccordionHeader',{key:("accordion-" + (item.key)),class:[
					'group',
					'w-full px-sm/h py-xs/v',
					'transition-colors duration-100 ease-smooth-out',
					{
						'text-white >=1024:text-text': !_vm.panelsOpen[index],
						'text-theme': _vm.panelsOpen[index],
					} ],attrs:{"id":("accordion-" + (item.key)),"aria-controls":("panel-" + (item.key))}},[_c('div',{staticClass:"flex justify-between items-center align-baseline"},[_c('div',{class:[
							'pr-(1/4)/12col >=1024:pr-xs/h',
							'transform duration-200 ease-smooth-out',
							{
								'>=1024:translate-x-2xs/h':
									_vm.panelsOpen[index],
							} ]},[_vm._t("header",function(){return [_c('BaseH3',{staticClass:"text-card-title-sm font-light",domProps:{"textContent":_vm._s(item.content.title)}})]},null,{
								item: item,
								index: index,
								isActive: _vm.panelsOpen[index],
							})],2),_vm._v(" "),_c('BaseButton',{class:[
							'w-40 h-40 p-0 flex-shrink-0',
							'flex items-center justify-center',
							'rounded-full border >=1024:border-theme',
							'hover:bg-theme-90 group-hover:bg-theme-90',
							'transition duration-200 ease-in-out',
							{
								'>=1024:bg-theme >=1024:text-white transform -rotate-180':
									_vm.panelsOpen[index],
								'>=1024:bg-white >=1024:hover:bg-theme-10 >=1024:group-hover:bg-theme-10 >=1024:text-theme':
									!_vm.panelsOpen[index],
							} ],attrs:{"tag":"div"}},[_c('SvgIconWedge',{staticClass:"w-12 h-8 transform translate-y-1"})],1)],1)]),_vm._v(" "),_c('AccordionPanel',{key:("panel-" + (item.key)),ref:("panel-" + index),refInFor:true,staticClass:"px-sm/h",attrs:{"id":("panel-" + (item.key)),"transition":{ name: 't-accordion' }},on:{"change":function (event) { return _vm.onPanelChange(event, index); }}},[_c('div',{class:[
						'transform >=1024:pr-2xs/h',
						'duration-200 ease-smooth-out',
						{
							'>=1024:translate-x-2xs/h': _vm.panelsOpen[index],
						} ]},[_c('div',{staticClass:">=1024:pr-2xs/h pb-lg/v"},[_vm._t("panel",null,null,{
								item: item,
								index: index,
								isActive: _vm.panelsOpen[index],
							})],2)])])],1)}),0)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }